var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 13.9996L14.5 13L14.4301 13.7296C15.6301 12.3296 16.2501 10.4196 15.9101 8.38965C15.4401 5.60965 13.1201 3.38965 10.3201 3.04965C6.09014 2.52965 2.53014 6.08965 3.05014 10.3196C3.39014 13.1196 5.61014 15.4396 8.39014 15.9096C10.4201 16.2496 12.3301 15.6296 13.7301 14.4296L13 14.5L14.0001 15.4996L18.2501 19.7496C18.6601 20.1596 19.3301 20.1596 19.7401 19.7496C20.1501 19.3396 20.1501 18.6696 19.7401 18.2596L15.5001 13.9996ZM9.50014 13.9996C7.01014 13.9996 5.00014 11.9896 5.00014 9.49965C5.00014 7.00965 7.01014 4.99965 9.50014 4.99965C11.9901 4.99965 14.0001 7.00965 14.0001 9.49965C14.0001 11.9896 11.9901 13.9996 9.50014 13.9996Z",
    fill: "#8E93A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dff238e0.svg";
export { ForwardRef as ReactComponent };